module.exports = __webpack_public_path__ + "static/Gym-Mobile-10-23-6d106ab54176752834f5ba8094d702e6.jpg";